/** @format */
import { request } from 'src/utils'

const API = {
  getAlertUser: '/monitor/?Action=GetContact&Version=2021-01-01', // 获取联系人
  getUserGroup: '/monitor/?Action=GetContactGroup&Version=2021-01-01', // 获取联系组
  delAlertUse: '/monitor/?Action=DeleteAlertUser&Version=2021-01-01&Cap=1', // 删除联系人
  updateAlertUseStatus: '/monitorapi/users/updateAlertUserStatus', // 启用/禁用联系人
  getVerifyCode: '/monitor/?Action=SendVerify&Version=2021-01-01', // 发送验证码
  createAlertUser: '/monitor/?Action=CreateContact&Version=2021-01-01', // 创建联系人
  updateAlertUser: '/monitor/?Action=ModifyContact&Version=2021-01-01', //修改联系人
  createUserGroup: '/monitor/?Action=CreateContactGroup&Version=2021-01-01', //创建联系组
  updateUserGroup: '/monitor/?Action=UpdateContactGroup&Version=2021-01-01&Cap=1', // 编辑联系组
  delUserGroup: '/monitor/?Action=DeleteUserGroup&Version=2021-01-01&Cap=1', // 删除联系组
  // 值班表
  getScheduleList: '/monitor/?Action=ListOncallSchedules&Version=2026-01-01', // 获取值班表列表
  getScheduleDetail: '/monitor/?Action=GetOncallSchedule&Version=2026-01-01', // 获取值班表详情
  createSchedule: '/monitor/?Action=CreateOncallSchedule&Version=2026-01-01', // 创建值班表
  updateSchedule: '/monitor/?Action=UpdateOncallSchedule&Version=2026-01-01', // 更新值班表
  deleteSchedule: '/monitor/?Action=DeleteOncallSchedule&Version=2026-01-01' // 删除值班表
}

export const getScheduleList = async params => {
  const result = await request(API.getScheduleList, {
    method: 'GET',
    data: params
  })
  return result?.data?.data || {}
}

export const getScheduleDetail = async ScheduleID => {
  const result = await request(API.getScheduleDetail, {
    method: 'GET',
    data: { ScheduleID }
  })
  return result?.data?.data || {}
}

export const createSchedule = async params => {
  const result = await request(API.createSchedule, {
    method: 'POST',
    data: params
  })
  return result
}

export const updateSchedule = async params => {
  const result = await request(API.updateSchedule, {
    method: 'POST',
    data: params
  })
  return result
}

export const deleteSchedule = async ScheduleID => {
  const result = await request(API.deleteSchedule, {
    method: 'POST',
    data: { ScheduleID }
  })
  return result
}
export default API
